import {Tag, Tooltip, Button, Typography} from 'antd';
import dayjs from 'dayjs';
import NumberFormat from 'react-number-format';
import React from 'react';
import {
  ExportOutlined,
  CalendarOutlined,
  UserOutlined,
  DollarOutlined,
  PercentageOutlined,
  BankOutlined,
} from '@ant-design/icons';

const {Text} = Typography;

const columns = () => [
  {
    title: <Text strong style={{fontSize: 12}}>Código</Text>,
    key: 'codigo',
    dataIndex: 'codigo_contrato',
    width: 148,
    render: (_, {codigo_contrato}) => (
      <div className='bc-code-cell'>
        <span className='bc-code-text'>{codigo_contrato}</span>
        <Tooltip title='Abrir en nueva pestaña'>
          <Button
            className='bc-open-btn'
            type='primary'
            size='small'
            icon={<ExportOutlined style={{color: '#fff', fontSize: 11}} />}
            onClick={() => window.open('/contrato/' + codigo_contrato, '_blank')}
          />
        </Tooltip>
      </div>
    ),
  },
  {
    title: <Text strong style={{fontSize: 12}}>Tipo</Text>,
    key: 'tipo',
    width: 120,
    render: (_, {tipo_contrato}) => (
      <Tag
        color={tipo_contrato.tipo_contrato_color}
        style={{borderRadius: 6, fontWeight: 500, fontSize: 11, padding: '2px 8px'}}>
        {tipo_contrato.nombre_contrato}
      </Tag>
    ),
  },
  {
    title: <Text strong style={{fontSize: 12}}>Estado</Text>,
    key: 'estado',
    width: 190,
    render: (_, contrato) => (
      <Tag
        color={
          contrato.estado_contrato.rgb_estado_contrato ||
          contrato.estado_contrato.color_estado_contrato
        }
        style={{borderRadius: 8, fontWeight: 500, fontSize: 11, padding: '3px 10px'}}>
        {contrato.estado_contrato.nombre_estado_contrato}
      </Tag>
    ),
  },
  {
    title: (
      <Text strong style={{fontSize: 12}}>
        <CalendarOutlined style={{marginRight: 4}} />
        Fecha de pago
      </Text>
    ),
    key: 'fechaCreacion',
    width: 130,
    render: (_, {fecha_fin_contrato}) => (
      <div className='bc-date-cell'>
        <CalendarOutlined className='bc-date-icon' />
        {dayjs(fecha_fin_contrato).add(6, 'hours').format('DD/MM/YYYY')}
      </div>
    ),
  },
  {
    title: (
      <Text strong style={{fontSize: 12}}>
        <UserOutlined style={{marginRight: 4}} />
        Cliente
      </Text>
    ),
    key: 'cliente',
    width: 210,
    render: (_, {actores_contrato}) => (
      <div className='bc-client-cell'>
        <span className='bc-client-icon'>
          <UserOutlined />
        </span>
        <Text ellipsis style={{maxWidth: 170, fontSize: 13}}>
          {actores_contrato[0].cliente.nombre_cliente}{' '}
          {actores_contrato[0].cliente.apellido_cliente}
        </Text>
      </div>
    ),
  },
  {
    title: (
      <Text strong style={{fontSize: 12}}>
        <BankOutlined style={{marginRight: 4}} />
        Monto otorgado
      </Text>
    ),
    key: 'montoOtorgado',
    width: 140,
    render: (_, {monto_total_prestamo}) => (
      <span className='bc-monto-cell'>
        <NumberFormat
          value={monto_total_prestamo}
          displayType='text'
          thousandSeparator
          prefix='Q '
        />
      </span>
    ),
  },
  {
    title: (
      <Text strong style={{fontSize: 12}}>
        <PercentageOutlined style={{marginRight: 4}} />
        Saldo interés
      </Text>
    ),
    key: 'saldointeres',
    width: 130,
    render: (_, {saldo_actual}) => (
      <span className='bc-saldo-cell bc-saldo-cell--interes'>
        <NumberFormat
          value={parseFloat(saldo_actual[0].saldo_intereses).toFixed(2)}
          displayType='text'
          thousandSeparator
          prefix='Q '
        />
      </span>
    ),
  },
  {
    title: (
      <Text strong style={{fontSize: 12}}>
        <DollarOutlined style={{marginRight: 4}} />
        Saldo capital
      </Text>
    ),
    key: 'saldocapital',
    width: 130,
    render: (_, {saldo_actual}) => (
      <span className='bc-saldo-cell bc-saldo-cell--capital'>
        <NumberFormat
          value={parseFloat(saldo_actual[0].saldo_capital).toFixed(2)}
          displayType='text'
          thousandSeparator
          prefix='Q '
        />
      </span>
    ),
  },
];

export default columns;
